import React, { useState, useEffect } from 'react';

import Button from '../Button';

import './styles.scoped.css';

const ActionOnBehalfModal = ({ isOpen, onClose, onApprove, onReject, userEmail, userName, isLoading }) => {
  const [clientName, setClientName] = useState('');
  const [rejectReason, setRejectReason] = useState('');
  const [clientNameError, setClientNameError] = useState('');
  const [rejectReasonError, setRejectReasonError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setClientName('');
      setRejectReason('');
      setClientNameError('');
      setRejectReasonError('');
    }
  }, [isOpen]);

  const currentDateTime = new Date().toLocaleString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  const handleApprove = () => {
    setClientNameError('');
    if (!clientName.trim()) {
      setClientNameError('Please enter the client name.');
      return;
    }
    onApprove(clientName.trim());
  };

  const handleReject = () => {
    setClientNameError('');
    setRejectReasonError('');
    let hasError = false;
    if (!clientName.trim()) {
      setClientNameError('Please enter the client name.');
      hasError = true;
    }
    if (!rejectReason.trim()) {
      setRejectReasonError('Please enter the reject reason.');
      hasError = true;
    }
    if (hasError) return;
    onReject(clientName.trim(), rejectReason.trim());
  };

  if (!isOpen) return null;

  return (
    <div className="overlay">
      <div className="dialog">
        <div className="dialog-header">Action on behalf of customer</div>
        <div className="dialog-body">
          <div className="info-row">
            <div className="info-field">
              <span className="field-label">User</span>
              <span className="field-value">{userEmail}</span>
            </div>
            <div className="info-field">
              <span className="field-label">User Name</span>
              <span className="field-value">{userName}</span>
            </div>
            <div className="info-field">
              <span className="field-label">Date and Time</span>
              <span className="field-value">{currentDateTime}</span>
            </div>
          </div>

          <div className="form-field">
            <label className="field-label">
              Enter Client Name, action on behalf of <span className="required">*</span>
            </label>
            <div className="input-col">
              <input
                className={`text-input ${clientNameError ? 'input-error' : ''}`}
                type="text"
                value={clientName}
                onChange={e => setClientName(e.target.value)}
                maxLength={50}
              />
              {clientNameError && <span className="error-message">{clientNameError}</span>}
            </div>
          </div>

          <div className="form-field">
            <label className="field-label">
              Reason for Rejection required if rejecting <span className="required">*</span>
            </label>
            <div className="input-col">
              <textarea
                className={`text-area ${rejectReasonError ? 'input-error' : ''}`}
                value={rejectReason}
                onChange={e => setRejectReason(e.target.value)}
                maxLength={300}
                rows={4}
              />
              {rejectReasonError && <span className="error-message">{rejectReasonError}</span>}
            </div>
          </div>

          <div className="button-row">
            {isLoading && <span className="spinner" />}
            <Button variant="outline" onPress={handleApprove} disabled={isLoading} text="Approve" />
            <Button variant="primary" onPress={handleReject} disabled={isLoading} text="Reject" />
            <Button variant="outline" onPress={onClose} text="Cancel" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActionOnBehalfModal;
